import { axiosClient } from '@nx-frontend/shared/api';
import { AddSubscriptionAddonPayload, SubscriptionDto } from '@nx-frontend/shared/types';

export const addSubscriptionAddon = async ({
  userId,
  subscriptionId,
  orgId,
  code,
  quantity,
}: AddSubscriptionAddonPayload): Promise<SubscriptionDto | null> => {
  const body: Record<string, unknown> = {
    code,
    orgId,
  };
  if (quantity !== undefined) {
    body['quantity'] = quantity;
  }
  const response = await axiosClient.post(`/v2/api/billing/subscriptions/${subscriptionId}/addons`, body, { userId });
  return response.data as SubscriptionDto;
};
